import { render, staticRenderFns } from "./PanelFilter.vue?vue&type=template&id=0f806e1a&scoped=true&"
import script from "./PanelFilter.vue?vue&type=script&lang=js&"
export * from "./PanelFilter.vue?vue&type=script&lang=js&"
import style0 from "./PanelFilter.vue?vue&type=style&index=0&id=0f806e1a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f806e1a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/apps/oil/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f806e1a')) {
      api.createRecord('0f806e1a', component.options)
    } else {
      api.reload('0f806e1a', component.options)
    }
    module.hot.accept("./PanelFilter.vue?vue&type=template&id=0f806e1a&scoped=true&", function () {
      api.rerender('0f806e1a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "node_modules/vue-excel-editor/src/PanelFilter.vue"
export default component.exports